const TrueOrFalseModal = ({
    handleSubmit = () => { },
    modalRef,
    modalTitle = "",
    modalDesc = "",
    isSubmit = false,
}) => {
    return (
        <div className="modal fade" id="delete" ref={modalRef} tabIndex="-1">
            <div className="modal-dialog modal-md">
                <form onSubmit={handleSubmit}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{modalTitle}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {modalDesc}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light" data-bs-dismiss="modal">Tutup</button>
                            <button type="submit" disabled={isSubmit} className="btn btn-primary" data-bs-dismiss="modal">{isSubmit ? "Menghapus..." : "Ya"}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default TrueOrFalseModal